import { latestFeed } from "@/mocks/homeData";

export default function LatestFeed() {
  return (
    <section id="latest" className="w-full border-b border-background-200/70 bg-background-100 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 flex flex-col gap-3 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium text-primary-600 md:text-sm">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-flashlight-line text-base" aria-hidden="true"></i>
              </span>
              模块 06 · 最新爆料
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              最新爆料动态流
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              按时间倒序排列的索引条目，每条都标注了关键词分组与当前热度，方便你判断线索的讨论规模。
            </p>
          </div>
          <div className="flex w-fit items-center gap-2 rounded-full border border-background-300/70 bg-background-50 px-3.5 py-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center text-primary-600">
              <i className="ri-refresh-line text-base" aria-hidden="true"></i>
            </span>
            <span className="text-xs font-medium text-foreground-700 md:text-sm">约 30 分钟前同步</span>
          </div>
        </div>

        <div className="overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
          {latestFeed.map((item, index) => (
            <a
              key={item.title}
              href="#zones"
              className={`group flex items-start gap-4 px-4 py-4 transition-colors hover:bg-background-100/70 md:px-6 md:py-5 ${
                index !== 0 ? "border-t border-background-200/70" : ""
              }`}
            >
              <div className="hidden w-24 shrink-0 pt-0.5 sm:block">
                <p className="text-xs text-foreground-500 md:text-sm">{item.time}</p>
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-900">
                    {item.tag}
                  </span>
                  <h3 className="min-w-0 text-sm font-semibold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-base">
                    {item.title}
                  </h3>
                </div>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {item.summary}
                </p>
                <p className="mt-2 text-xs text-foreground-500 sm:hidden">{item.time}</p>
              </div>

              <div className="flex shrink-0 flex-col items-end gap-1 pt-0.5">
                <span className="flex items-center gap-1 text-xs font-semibold text-primary-600 md:text-sm">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-fire-line text-sm" aria-hidden="true"></i>
                  </span>
                  {item.heat}
                </span>
                <span className="hidden h-5 w-5 items-center justify-center text-foreground-400 transition-transform group-hover:translate-x-0.5 sm:flex">
                  <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}